import { produce } from 'immer';

import { RESET_STATE } from 'store/global/actions';

import { PROGRAM_ACTION_TYPE } from '../actions';

const initialState = {};

const programsReducer = (state = initialState, { type, payload, meta }) =>
  produce(state, draft => {
    switch (type) {
      case PROGRAM_ACTION_TYPE.GET_PROGRAMS:
        return payload || initialState;

      case PROGRAM_ACTION_TYPE.CREATE_PROGRAM:
      case PROGRAM_ACTION_TYPE.EDIT_PROGRAM:
      case PROGRAM_ACTION_TYPE.ACTIVATE_PROGRAM:
        draft[payload.programId] = payload;
        break;

      case PROGRAM_ACTION_TYPE.DELETE_PROGRAM:
        draft[meta.programId].isDeleted = true;
        break;

      case RESET_STATE:
        return initialState;

      default:
        return state;
    }
  });

export default programsReducer;
